import BaseRestMutations from "@/store/base-rest.mutations";
import {make} from "vuex-pathify";
import store from "@/store";
import AppService from "@/services/app.service";
import {EventService} from "@/services";
import Vue from "vue";

const state = {
    items: [],
    currentItem: {}
}
const mutations = BaseRestMutations(state)

const actions = {
    ...make.actions(state),
    create({commit}, item) {
        store.set('app/loading', true)
        EventService.create(item)
            .then((res) => {
                commit('pushItem', res.data)
                AppService.toastSuccess("Create event successfully")
                store.set('dialogs/showEventForm', false)
            })
            .catch(() => {
                AppService.toastError("Create event failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })

    },
    findAll({dispatch}) {
        store.set('app/loading', true)
        EventService.findAll()
            .then(res => {
                dispatch('setItems', res.data)
            })
            .catch(() => {
                AppService.toastError("Get list event failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })
    },
    update({commit, dispatch}, item) {
        store.set('app/loading', true)
        EventService.update(item.id, item)
            .then((res) => {
                commit('updateItem', res.data)
                store.set('dialogs/showEventForm', false)
                AppService.toastSuccess("Update event successfully")
            })
            .catch(() => {
                AppService.toastError("Update event failed")
            })
            .finally(() => {
                dispatch('setCurrentItem', {})
                store.set('app/loading', false)
            })
    },
    remove({commit}, id) {
        Vue.$confirm(
            {
                message: `You sure want to delete event?`,
                button: {
                    no: 'Cancel',
                    yes: 'OK'
                },
                callback: confirm => {
                    if (confirm) {
                        store.set('app/loading', true)
                        EventService.remove(id)
                            .then(() => {
                                commit('removeItem', id);
                                AppService.toastSuccess("Delete event successfully")
                            })
                            .catch(() => {
                                AppService.toastError("Delete event failed")
                            })
                            .finally(() => {
                                store.set('app/loading', false)
                            })
                    }
                }
            }
        )

    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
